<div class="filter-container">
  <div class="row">
    <!-- Filtro por Trabajador -->
    <div class="col-md-3">
      <mat-form-field appearance="outline">
        <mat-label>Filtrar por trabajador</mat-label>
        <mat-select [(ngModel)]="workersFilter" multiple>
          <mat-option (click)="onSelectWorkerNotAsigned()" [value]="'notAsigned'">Sin Asignar</mat-option>
          <mat-option (click)="onSelectWorker()" *ngFor="let worker of workers" [value]="worker._id">
            {{ worker.firstname }} {{ worker.lastname }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Filtro por Cliente -->
    <div class="col-md-3">
      <mat-form-field appearance="outline">
        <mat-label>Filtrar por cliente</mat-label>
        <mat-select name="clients" [(ngModel)]="clientsFilter" multiple (ngModelChange)="$event && onSelectClient()">
          <mat-option *ngFor="let client of clients" [value]="client._id">
            {{client.firstname}} {{client.lastname}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Filtro por Estado -->
    <div class="col-md-6">
      <div class="status-filters">
        Filtrar trabajos por estado: <br><br>
        <button mat-raised-button class="m-0 ml-1 btn custom-button" [ngStyle]="{'background-color': colorStatusScheduled}"
          (click)="applyStatusFilter('SCHEDULED')">Programados</button>
        <button mat-raised-button class="m-0 ml-1 btn custom-button" [ngStyle]="{'background-color': colorStatusOnGoing}"
          (click)="applyStatusFilter('ONGOING')">En Curso</button>
        <button mat-raised-button class="m-0 ml-1 btn custom-button" [ngStyle]="{'background-color': colorStatusCompleted}"
          (click)="applyStatusFilter('COMPLETED')">Completados</button>
        <button mat-raised-button class="m-0 ml-1 btn custom-button" [ngStyle]="{'background-color': colorStatusInvoiced}"
          (click)="applyStatusFilter('INVOICED')">Facturados</button>
        <button mat-raised-button class="m-0 ml-1 btn" (click)="applyStatusFilter('ACTIVE')">Todos</button>
      </div>
    </div>
  </div>
</div>

<div class='calendar-app'>
  <div class='calendar-app-main'>
    <full-calendar #calendar *ngIf='calendarVisible()' [options]='calendarOptions()'>
      <ng-template #eventContent let-arg>
        <i>{{ arg.event.title }}</i>
      </ng-template>
    </full-calendar>
  </div>
</div>